import { render, staticRenderFns } from "./Informasi.vue?vue&type=template&id=046b5c2a"
import script from "./Informasi.vue?vue&type=script&lang=js"
export * from "./Informasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports